export enum RiskService {
  BedriddenPatient = 'bedridden_patient',
  Suction = 'suction',
  OstomyCare = 'ostomy_care',
  Feeding = 'feeding',
  TubeFeeding = 'tube_feeding',
  GastrostomyTube = 'gastrostomy_tube',
  None = 'none',
}

export const RiskServiceLabel = {
  [RiskService.BedriddenPatient]: '와상',
  [RiskService.Suction]: '석션',
  [RiskService.OstomyCare]: '장루케어',
  [RiskService.Feeding]: '위관영양(피딩)',
  [RiskService.TubeFeeding]: '콧줄식사',
  [RiskService.GastrostomyTube]: '위루관 케어',
  [RiskService.None]: '해당 없음',
}
